/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_Field_NameInputs */

const tr_contact_form_field_name = /** @type {(inputs: Contact_Form_Field_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ad Soyad *`)
};

const en_contact_form_field_name = /** @type {(inputs: Contact_Form_Field_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full Name *`)
};

const de_contact_form_field_name = /** @type {(inputs: Contact_Form_Field_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vor- und Nachname *`)
};

const ru_contact_form_field_name = /** @type {(inputs: Contact_Form_Field_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Имя и Фамилия *`)
};

/**
* | output |
* | --- |
* | "Full Name *" |
*
* @param {Contact_Form_Field_NameInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const contact_form_field_name = /** @type {((inputs?: Contact_Form_Field_NameInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_Field_NameInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contact_form_field_name(inputs)
	if (locale === "de") return de_contact_form_field_name(inputs)
	if (locale === "ru") return ru_contact_form_field_name(inputs)
	return tr_contact_form_field_name(inputs)
});